var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLearningAdaptiveWrong = function SvgLearningAdaptiveWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 12,
    r: 11,
    fill: "#FB5058",
    stroke: "#FB5058",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39251 8.14205C8.93022 7.60434 9.802 7.60434 10.3397 8.14205L12.1199 9.9222L13.9 8.14205C14.4377 7.60434 15.3095 7.60434 15.8472 8.14205C16.3849 8.67975 16.3849 9.55154 15.8472 10.0892L14.0671 11.8694L15.8472 13.6495C16.3849 14.1873 16.3849 15.059 15.8472 15.5967C15.3095 16.1344 14.4377 16.1344 13.9 15.5967L12.1199 13.8166L10.3397 15.5967C9.802 16.1344 8.93022 16.1344 8.39251 15.5967C7.85481 15.059 7.85481 14.1873 8.39251 13.6495L10.1727 11.8694L8.39251 10.0892C7.85481 9.55154 7.85481 8.67975 8.39251 8.14205Z",
    fill: "white"
  })));
};
export default SvgLearningAdaptiveWrong;